import React, { useEffect, useMemo, useState } from 'react'

import { MultiSelectWithSelectAll } from '@ublique/components/MultiSelect'
import withDocument from 'components/Wizard/elements/withDocument'
import { getOptionLabel } from '../helpers/input-element'

const MultiSelect = ({
  t,
  id,
  option,
  label,
  value,
  setValue,
  valueKey,
  hidden,
  onBlur,
  invalid,
  disabled,
  invalidText,
  preSelectAll
}) => {
  const items = useMemo(
    () =>
      hidden
        ? []
        : option.map(({ label, value }) => ({
            label: getOptionLabel(t, label),
            value: { [valueKey]: value }
          })),
    [hidden, option, t, label, valueKey]
  )

  const onChange = ({ selectedItems }) => {
    setValue(id, selectedItems)
  }

  const [initialSelectedItems, setInitialSelectedItems] = useState([])
  useEffect(() => {
    // Do not initialize selected items if the item is hidden or if the selected items are already initialized
    const initNotNeeded = hidden || initialSelectedItems.length
    if (initNotNeeded) {
      return
    }

    // Initially, if there is a default selection, the wizard change is triggered
    const isFirstChange =
      value === '' && ((items.length && preSelectAll) || items.length === 1)
    if (isFirstChange) {
      onChange({ selectedItems: items })
    }

    // At the end of the wizard change, the initial selected items are synchronized
    const canSetInitialItems = value && value.length
    if (canSetInitialItems) {
      setInitialSelectedItems(value)
    }
  }, [hidden, value, preSelectAll, items, initialSelectedItems])

  const [key, setKey] = useState(0)
  useEffect(() => {
    setKey((prevKey) => prevKey + 1)
  }, [initialSelectedItems])

  if (hidden) {
    return null
  }

  const multiselectProps = {
    key,
    id,
    label,
    hidden,
    invalid,
    disabled,
    invalidText,
    light: true,
    onBlur: onBlur,
    titleText: t(label),
    onChange,
    btnLabels: {
      select: t('SELECT_ALL'),
      deselect: t('DESELECT_ALL')
    },
    selectOptions: true,
    useTitleInItem: false,
    initialSelectedItems,
    itemToString: (item) => item.label,
    items
  }

  return <MultiSelectWithSelectAll {...multiselectProps} />
}

export default withDocument(MultiSelect)
